'use client';

import type { LinkProps } from 'next/link';
import Link from 'next/link';

import { STORAGE_KEY } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

interface CustomLinkProps
  extends
    Omit<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      keyof LinkProps | 'ref'
    >,
    LinkProps {}

export const CustomLink = ({
  replace,
  children,
  onClick,
  onMouseEnter,
  href,
  prefetch = false,
  ref,
  ...props
}: CustomLinkProps & { ref?: React.Ref<HTMLAnchorElement> }) => {
  const router = useCustomRouter();

  return (
    <Link
      {...props}
      ref={ref}
      href={href}
      replace={replace}
      prefetch={prefetch}
      onMouseEnter={(e) => {
        if (!prefetch) {
          router.prefetch(getPathnameFromHref(href));
        }
        onMouseEnter?.(e);
      }}
      onClick={(e) => {
        if (replace) {
          sessionStorage.setItem(STORAGE_KEY.REPLACE_MARK, 'true');
          sessionStorage.setItem(STORAGE_KEY.REPLACE_MARK_KB, 'true');
        }

        onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
};

const getPathnameFromHref = (href: LinkProps['href']): string => {
  if (typeof href === 'string') {
    // 절대 URL인 경우 pathname 추출
    if (href.startsWith('http://') || href.startsWith('https://')) {
      try {
        return new URL(href).pathname;
      } catch {
        return href;
      }
    }

    // 상대 경로인 경우 query string 제거 후 반환
    return href.split('?')[0].split('#')[0];
  }

  // UrlObject인 경우 pathname 사용
  return href.pathname || '';
};
